import React from "react";
import { Field } from "formik";

const FormField = ({
  name,
  label,
  type = "text",
  placeholder,
  touched,
  errors,
  handleBlur,
  handleChange,
  setFieldValue,
  value,
  col_md = "4",
  disabled = false,
  required = true,
  readOnly = false,
}) => {
  return (
    <div className={`col-lg-${col_md} col-sm-6 mb-3`}>
      <label
        className={`form-label ${required ? "required-label" : ""} `}
        htmlFor={name}
      >
        {label}
      </label>
      <Field
        readOnly={readOnly}
        disabled={disabled}
        type={type}
        name={name}
        className={`form-control !tw-mt-0 ${
          touched[name] && errors[name] ? "custom-invalid-input" : ""
        }`}
        placeholder={placeholder}
        onBlur={handleBlur}
        onChange={
          type === "text" && !name.startsWith("phone")
            ? handleChange
            : (e) => {
                const { value } = e.target;
                if (name.startsWith("phone")) {
                  const sanitizedValue = value.replace(/\D/g, "");
                  const truncatedValue = sanitizedValue.slice(0, 11);
                  setFieldValue(name, truncatedValue);
                } else {
                  setFieldValue(name, value);
                }
              }
        }
        value={value}
      />
      {touched[name] && errors[name] && (
        <div className="invalid-feedback">{errors[name]}</div>
      )}
    </div>
  );
};

export default FormField;
